import _performance from '../init/performance'
import { TSG_ID } from './constants'
import { getDatadogRum } from './externals'
import { stateRef } from './states'
import { getReactTextElementText } from './utils'
import type { NavAppAttr } from './microAppTypes'
import type { NavItem, UserState } from './types'

const EMPTY_NAV_ITEM = {} as NavItem
export const getCurrentTsgDebugInfo = (locUrl: string = window.location.href) => {
  const { auth, activeSubNavItem, contentNavItemRef } = stateRef.current
  const { tsg_id, instances, tsgs, access, user: { email, subname: userid, supportAccountIds } = {} as UserState } = auth
  const datadogRum = getDatadogRum()
  const currentNavItem = (contentNavItemRef.current || activeSubNavItem || EMPTY_NAV_ITEM) as NavItem
  const tsgUrl = new URL(locUrl)
  if (tsg_id) {
    tsgUrl.searchParams.set(TSG_ID, tsg_id)
  }
  const url = tsgUrl.toString()
  const { platform_region, support_account_id } = instances || {}
  const cspId = support_account_id ? +support_account_id : undefined
  const support_account_name = cspId && Array.isArray(supportAccountIds) ? supportAccountIds.find(acc => acc.accountid === cspId)?.name : undefined
  const tsg_name = tsgs?.get(tsg_id!)?.display_name || null
  const netsec_session_id = datadogRum?.getGlobalContext()?.netsecSessionId as string | undefined
  const { session_id: dd_session_id, view } = datadogRum?.getInternalContext() || {}
  const { breadcrumbs, title, component, appName, microAppId: navMicroAppId = appName, key, path: pagePath = key } = currentNavItem
  const page_micro_app = (component as NavAppAttr)?.microAppId || navMicroAppId
  const page_name = breadcrumbs?.join(' > ') || getReactTextElementText(title) || pagePath
  const dd_view_id = view?.id
  const { speed: network_speed, timing: { micro_apps, ...sparky_timing } } = _performance
  const info = {
    tsg_id,
    tsg_name,
    support_account_id,
    support_account_name,
    title: document.title,
    page_name,
    page_micro_app,
    platform_region,
    url,
    email,
    userid,
    netsec_session_id,
    dd_session_id,
    dd_view_id,
    tsg_instances: instances?.map(({
      tenant_id,
      tsg_tenant_id,
      app_id,
      support_account_id,
      serial_number,
      region,
      status,
      provisioning_status,
    }) => ({
      tenant_id,
      tsg_tenant_id,
      app_id,
      support_account_id,
      serial_number,
      region,
      status,
      provisioning_status,
    })),
    access: access?.rawAccessObject,
    network_speed: network_speed || undefined,
    sparky_timing,
    generated: Date.now(),
  }
  return info
}
